export const CONTENT_PUBLISHER_SHOW_TABS = [
  'general',
  'contracts',
  'integration',
] as const;

export type ContentPublisherShowTab =
  (typeof CONTENT_PUBLISHER_SHOW_TABS)[number];

export const CONTENT_PUBLISHER_DEFAULT_TAB: ContentPublisherShowTab = 'general';
